import React from 'react';
import PropTypes from 'prop-types';
import Payments from '../../../api/api-payments';
import { CTAButton } from 'shared-components/buttons/cta-button';
import _ from 'lodash';

import { TosCTAdisclaimer } from 'shared-components/terms/cta-disclaimer';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

class StripeIntroComponent extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      isSubmitted: false,
      errorMessage: ''
    };

    this.createStripeLink = this.createStripeLink.bind(this);
  }

  componentDidMount () {
    window.scrollTo(0, 0);
  }

  createStripeLink () {
    analyticsIntegrations.formSubmit('createStripeLink');
    this.setState({
      isSubmitted: true,
      errorMessage: ''
    }, () => {
      const { linkType, token, profile } = this.props;
      const ssoId = profile?.SSOid;
      const tosPayload = {
        tos_acceptance: {
          service_agreement: 'recipient'
        }
      };

      // Accept ToS for host
      Payments.saveManagedAccountData(ssoId, token, tosPayload, true, (updateRes) => {
        const { error } = updateRes;
        if (error) {
          analyticsIntegrations.formFail('createStripeLink', error);
          return this.resetForm(error);
        }

        Payments.getStripeAccountLink(linkType, token, (res) => {
          const { error, url } = res;
          if (error) {
            analyticsIntegrations.formFail('createStripeLink', error);
            return this.resetForm(error);
          }

          if (url) {
            return location.href = url;
          }
        });
      });
    });
  }

  resetForm (errorMessage) {
    this.setState({
      isSubmitted: false,
      errorMessage
    });
  }

  cancelButton () {
    const previousLocation = location.referrer || '/account/methods';
    location.href = previousLocation;
  }

  render () {
    const {
      isSubmitted,
      errorMessage
    } = this.state;

    const {
      inProgress,
      intl
    } = this.props;

    const buttonLabel = inProgress
      ? intl.formatMessage({ id: 'account.stripe_intro.continue', defaultMessage: 'Continue' })
      : intl.formatMessage({ id: 'account.stripe_intro.start_verification', defaultMessage: 'Start Verification' });
    return (
      <div className="ps-container-fixed ps-container-lg-margin stripe-intro-page">
        <div className="ps-row">
          <div className="col-sm-2 col-md-3" />
          <div className="col-xs-12 col-sm-8 col-md-6">
            <img className="margin-md-bottom" src="https://assets.peerspace.com/verify-account@2x.png" />
            <h4 className="text-center margin-lg-top">
              <FormattedMessage
                id="account.stripe_intro.header"
                defaultMessage="Verify Your Account"
              />
            </h4>
            <p className="text-gray-dark text-center text-small"><span className="icon-lock margin-md-right"></span>
              <FormattedMessage
                id="account.stripe_intro.caption"
                defaultMessage="Verification by Stripe"
              />
            </p>
            <div className="col-xs-12 no-gutter">
              <p className="text-center margin-xl-top">
                <FormattedMessage
                  id="account.stripe_intro.subheader"
                  defaultMessage="In order to get paid for your bookings, our payment provider needs to verify an authorized representative for the account and the business entity for your space."
                />
              </p>
              <div className="margin-xl-top">
                <CTAButton
                  isDisabled={isSubmitted}
                  onClickAction={this.createStripeLink}
                  spinning={isSubmitted}
                  buttonText={buttonLabel}
                  classNameString="btn btn-lg btn-primary margin-lg-top form"
                />
                <CTAButton
                  isDisabled={isSubmitted}
                  onClickAction={this.cancelButton}
                  buttonText={intl.formatMessage({ id: 'account.stripe_intro.cancel', defaultMessage: 'Cancel' })}
                  classNameString="btn btn-lg btn-default btn-outlined-light margin-lg-top form"
                />
              </div>
              <p className="error margin-sm-top">
                { errorMessage ?
                  <FormattedMessage
                    id="account.stripe_intro.error_message"
                    defaultMessage="Something went wrong. Wait a few moments and try again."
                  />
                  : ''}
              </p>
              <TosCTAdisclaimer buttonLabel={buttonLabel} location="banking" />
            </div>
          </div>
        </div>
      </div>);
  }
}

StripeIntroComponent.propTypes = {
  token: PropTypes.string,
  linkType: PropTypes.oneOf(['account_onboarding', 'account_update']),
  inProgress: PropTypes.bool,
  profile: PropTypes.object,
  intl: intlShape
};

export const StripeIntro = injectIntl(StripeIntroComponent);
